import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:131e0a93-069a-413d-8dcd-b0d11852c653',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_qYBwYIi6D',
  aws_user_pools_web_client_id: '766uoq99kpdbd3vke5ufqrmrim',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://o22g57vvgneu3phrqmu4k4fn5q.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-fakeApiId123456',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://n8stiid57b.execute-api.eu-west-1.amazonaws.com/crwinq',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage90604-crwinq',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'winq.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  APP_TITLE: 'WINQ',
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: true,
  ENABLE_MEDICAL_PROFILE: true,
  ENABLE_MANAGEMENT: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_INSIGHTS: false,
  ENABLE_OPERATION_PROFILE: true,
  ENABLE_STICKY_CAREPATHITEM: true,
  ENABLE_ACTIVATIONPERIOD_CAREPATHITEM: true,
  ENABLE_RANDOMISATION: true,
  AWS,
  defaultCarepathCards,
};
